export enum ProductSortProperty {
  Name = 'name',
  Price = 'price',
  Total = 'total',
  VatRate = 'vatPct',
}
